export class ArrayUtil {

    public static swapElements(array: Array<any>, index1: number, index2: number): void {
        var el: any = array[index1];
        array[index1] = array[index2];
        array[index2] = el;
    }


    public static removeElement(array: Array<any>, element: any): boolean {
        var index = array.indexOf(element);
        if (index == -1)
            return false;
        array.splice(index, 1);
        return true;
    }

    public static addUniqueElement(array: Array<any>, element: any): boolean {
        if (array.indexOf(element) != -1)
            return false;

        array.push(element);
        return true;
    }

    public static sortNumeric(arr, ascending) {
        if (ascending) {
            arr.sort((a, b) => a - b);
        } else {
            arr.sort((a, b) => b - a);
        }
        return arr;
    }

    public static sortNumericOn(arr, key, ascending) {
        if (ascending) {
            arr.sort((a, b) => a[key] - b[key]);
        } else {
            arr.sort((a, b) => b[key] - a[key]);
        }
        return arr;
    }

    public static setElementIndex(array: Array<any>, element: any, index: number): number {
        var order: number = array.indexOf(element);
        if (order == -1)
            return -1;

        index = Math.max(0, Math.min(array.length - 1, index));
        if (index != order) {
            array.splice(order, 1);
            array.splice(index, 0, element);
        }
        return index;
    }

    public static convertXMLAttributesToJson(node: Element): any {
        var json: any = {};
        for (let i: number = 0; i < node.attributes.length; ++i) {
            let value: any = node.attributes[i].value;
            if (value == 'true') {
                value = true;
            } else if (value == 'false') {
                value = false;
            }
            json[node.attributes[i].name] = value;
        }
        return json;
    }
}



// WEBPACK FOOTER //
// ./src/framework/utils/ArrayUtil.ts